export default {
  activeMode: 'active-mode',
  activeClass: "active",
  windowEl: window,
  documentEl: document,
  htmlEl: document.documentElement,
  bodyEl: document.body,
  header: document.querySelector('header'),
  footer: document.querySelector('footer'),
  overlay: document.querySelector('[data-overlay]'),
  mobileMenu: document.querySelector('.header-menu'),
  burger: document.querySelectorAll('.burger'),
  usefullSlider: document.querySelector('.usefull-section__slider'),
  feedbacksSlider: document.querySelector('.feedbacks-section__slider'),
  relatedSlider: document.querySelector('.related__slider'),
}





